import { combineReducers } from "@reduxjs/toolkit";
import planstatements from "./plan-statements";

const planStatementsReducer = combineReducers({
  planstatements,
});

export default planStatementsReducer;
